import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useMutation } from "@apollo/client";
import { CheckoutSessionData, POST_CHECKOUT_SESSION } from "../../api/Requests";
import UpgradeSubscription from "./UpgradeSubscription";

// const testStripeKey = "pk_test_51RHqgUFVm9asnzhthVWEOTV3tt6PFdcRWjjiLN0bPzODyNV1PQb8T9N7bjErpOTKHZpmQoD39KdGPnfRgQIrUgvU008nRdhWE8";
const liveStripeKey =
  "pk_live_51RHqgKJt1vptUN5MsjIIcGPumfvlozpLdv7yrZEayClgx3U0DLMSVOrqPslBgM8fc5GLiBl4e6Fb1yO0D1o1QfcE001gK1ZfbQ";
const stripePromise = loadStripe(liveStripeKey);

interface CheckoutFormProps {
  priceId: string;
  isSubscriptionActive: boolean;
}

export default function CheckoutForm({
  priceId,
  isSubscriptionActive,
}: CheckoutFormProps) {
  const [checkoutSessionCreate] = useMutation<CheckoutSessionData>(
    POST_CHECKOUT_SESSION,
  );
  const fetchClientSecret = async () => {
    return await checkoutSessionCreate({
      variables: {
        input: { priceId },
      },
    }).then(response =>
      response.data?.checkoutSession
        ? response.data.checkoutSession.client_secret
        : (() => {
            throw Error("Invalid checkout session");
          })(),
    );
  };

  if (isSubscriptionActive) {
    return <UpgradeSubscription priceId={priceId} />;
  }

  return (
    <EmbeddedCheckoutProvider
      stripe={stripePromise}
      options={{ fetchClientSecret }}
    >
      <EmbeddedCheckout />
    </EmbeddedCheckoutProvider>
  );
}
